import { render, staticRenderFns } from "./help-feedback.vue?vue&type=template&id=43b05870&scoped=true&"
import script from "./help-feedback.vue?vue&type=script&lang=js&"
export * from "./help-feedback.vue?vue&type=script&lang=js&"
import style0 from "./help-feedback.vue?vue&type=style&index=0&id=43b05870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b05870",
  null
  
)

export default component.exports